import OcrActivityContent from "./OcrActivityContent";

export default OcrActivityContent;